<div class="main">
  <div class="grid">
    <img src="assets/img/404.svg">
    <div class="text">
      <h1>{{ 'PAGE_NOT_FOUND.error' | translate }}</h1>
      <h3>{{ 'PAGE_NOT_FOUND.message' | translate }}</h3>
    </div>
  </div>
</div>
